import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArrowDownToBracket} from '@netx/core-icons';
import {canCreatePdfFromSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionCreatePDFDownloadIcon = faArrowDownToBracket;

/**
 * Create and download pdf from saved cart assets
 * @param params
 * @returns Action
 */
export const cartSavedActionCreatePDFDownload = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-create-pdf-download',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.CREATE_PDF_DOWNLOAD, savedCart),
	enableTest: () => canCreatePdfFromSavedCart(savedCart),
	icon: cartSavedActionCreatePDFDownloadIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.CREATE_PDF_DOWNLOAD;
	},
	...params,
});

export default cartSavedActionCreatePDFDownload;
